import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";

import { LeftAlignedGrid, RightAlignedGrid, DateText } from "./sharedStyles";

const EmptyGrid = styled(Grid)`
  && {
    text-align:right;
    margin-top:12px;
    font-size:17px;
  }
`;
const Totals = styled.div`
&&& {
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
}`;

const DefeasanceResult = ({ result }) => (
  <>
    <Grid container justify="flex-end">
      <LeftAlignedGrid item xs={6}>Next Payment Date</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}><DateText>{moment(result.calculationDate).format("MM/DD/YYYY")}</DateText></RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Security Portfolio</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.securityPortfolio, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Portfolio Yield</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatRate(result.portfolioYield, 2, "-")}</RightAlignedGrid>

    </Grid>

    <Grid container justify="flex-end">
      <EmptyGrid item xs={12}>{" "}</EmptyGrid>
      <LeftAlignedGrid item xs={6}>Servicer Fee</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.servicerFee, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Servicer Counsel Fee</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.servicerCounselFee, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Security Intermediary</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.securityIntermediary, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Accountant</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.accountant, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Rating Agency Fee</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.ratingAgencyFee, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Successor Borrower</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.successorBorrower, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Successor Borrower Counsel</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.successorBorrowerCounsel, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={6}>Defeasance Advisor</LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.defeasanceAdvisor, 2, "-")}</RightAlignedGrid>

      <LeftAlignedGrid item xs={12}><hr /></LeftAlignedGrid>
      <LeftAlignedGrid item xs={6}><Totals>Total Est. Third Party Fees</Totals></LeftAlignedGrid>
      <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.totalThirdPartyFees, 2, "-")}</RightAlignedGrid>
    </Grid>
  </>
);
export default DefeasanceResult;
